import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { AuthContext } from "../../../AuthContextWrapper";
import { RadioAndResponseForm } from "../shared/RadioAndResponseForm";
import { Estate } from "../../../models/Estate";
import { OUTCOMES } from "../../../constants";

export enum Outcomes {
  yes = "Yes",
  no = "No",
  dontKnow = "I don't know",
}

export const WillScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { flow, activeEstate, setActiveEstate } = useContext(AuthContext);
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  const handleComplete = async (hasWill: string): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    // const estate = activeEstate ? Estate.from(activeEstate) : new Estate();
    const estate = activeEstate || new Estate();
    estate.hasWill = hasWill;

    try {
      await estate.saveEstate();
      setActiveEstate && setActiveEstate(estate);
    } catch (error) {
      throw new Error("could not save data");
    }

    flow?.navigateToNext(currentScreen, OUTCOMES.complete, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper
      title={`Did ${activeEstate?.deceasedFirstName} have one or more wills?`}
      subTitle="This changes the legal requirements for the person(s) in charge of settling the estate."
    >
      <RadioAndResponseForm
        initAnswer={activeEstate?.hasWill}
        answerLabel="Will"
        errorText="Please select an option to continue"
        options={[
          { value: Outcomes.yes },
          { value: Outcomes.no },
          { value: Outcomes.dontKnow },
        ]}
        onComplete={handleComplete}
        onBack={() => navigate(-1)}
      />
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
